import {Component, OnInit} from '@angular/core';
import {KfChartsService} from '../../../../services/kf-charts.service';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../../utils/filters-utils';
import {VctCollectedChartData} from '../../../../models/vct-collected-chart-data.interface';

@Component({
  selector: 'app-vctp-up-to',
  templateUrl: './vctp-up-to.component.html',
  styleUrls: ['./vctp-up-to.component.scss']
})
export class VctpUpToComponent implements OnInit {

  text!: string;
  yearUsed = 0;
  subtitle = '';
  data!: VctCollectedChartData[];
  displayUnits = 'ABSOLUTE';
  years!: number[];
  secondYear = false;

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.kfChartsService.getYears('collected', 'COUNTRY_SCHEMA')
        .subscribe(data => {
          this.years = data;
          this.years.unshift(this.years[0] + 1);
          if (!search.startYear) {
            search.startYear = data[0];
          }
          if (!search.order) {
            search.order = 'alph';
          }
          this.yearUsed = search.startYear ? search.startYear : data[0];
          this.kfChartsService.getVCTPUpTo(search).subscribe(response => {
            this.data = response;
          });

          this.text = 'European collection target performance, ' + search.startYear;
          this.subtitle = '45% of Average Market input ' + (search.startYear - 3) + ' - ' + (search.startYear - 1) + ' (kg/inhabitant)';

          setTimeout(() => {
            if (this.data?.length == 0 || this.data == undefined) {
              this.yearUsed -= 1;
              search.startYear =  this.yearUsed;
              this.kfChartsService.getVCTPUpTo(search).subscribe(response => {
                this.data = response;
              });
              this.secondYear = true;

              this.text = 'European collection target performance, ' + search.startYear;
              this.subtitle = '45% of Average Market input ' + (search.startYear - 3) + ' - ' + (search.startYear - 1) + ' (kg/inhabitant)';
            }
          }, 500);
        });
    });
  }

  searchData(event: ChartsSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});

    if (event.displayUnits && event.displayUnits !== '') {
      this.displayUnits = event.displayUnits;
    }
  }

}
